<template>
  <section class="dd-message">
    <div class="dd-wall-card dd-message__card">
      <h2 class="dd-message__title">{{ title }}</h2>
      <div class="dd-message__actions">
        <router-link class="dd-post__btn" :to="backLink">{{ backLabel }}</router-link>
      </div>
    </div>
  </section>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  name: 'WallSent',
  computed: {
    isDonationOnly() {
      return this.$store.getters.donationOnlyMode || this.$route.name === 'WallSentDonation';
    },
    title() {
      return this.isDonationOnly ? this.$t('success.thank_you_for_your_donation') : this.$t('sent.done');
    },
    backLabel() {
      return this.isDonationOnly ? this.$t('success.go_back') : this.$t('sent.go_back');
    },
    backLink() {
      return this.isDonationOnly ? '/wall/effects' : '/wall/effects';
    },
  },
  methods: {
    ...mapMutations(['setMode']),
  },
  mounted() {
    this.setMode('sponsor');
  },
};
</script>
